module.exports = /* @ngInject */
(
    ReduxService
) => {
    return {
        /**
         * Get a user's profile
         * @return {Object}         $q promise that will be fulfilled by the profile response
         */
        getProfile() {
            return ReduxService.getProfile();
        }
    };
};
